<template>
  <div class="Projekte">
  <div class="d-none d-sm-block">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><router-link to="/">Übersicht</router-link> </li>
      <li class="breadcrumb-item active" aria-current="page">Projekte</li>
    </ol>
  </nav>
  </div>

    <div v-if="loading" class="d-flex justify-content-center mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>

    <b-alert v-if="!loading" :show="rows==0" variant="info">Aktuell keine Projekte</b-alert>

    <div class="table-responsive">
   <b-table ref="table" id="item-table" thead-class="d-none"
   :items="itemProvider"
   :current-page="currentPage"
   :per-page="perPage"
   :busy.sync="loading"
   :fields="fields" >
    <template #cell(auftragStatus)="data">
      <AuftragOverview ref="AuftragOverview" :auftrag="data.item" @refresh-list="refresh"/>
    </template>
    </b-table>
     </div>
     <b-pagination v-if="rows>perPage" v-model="currentPage" :total-rows="rows"
      :per-page="perPage" aria-controls="item-table"></b-pagination>
  </div>
</template>

<script>
import api from '@/api/workflow'
import utils from '@/utilities'
import afunc from '@/functions'
import AuftragOverview from '@/components/partials/AuftragOverview'

export default {
  name: 'Projekte',
  components: {AuftragOverview},
  data () {
    return {
      rows: 0,
      fields: ['auftragStatus'],
      perPage: 10,
      currentPage: 1,
      loading: false
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    uploadFile (id) {
      afunc.uploadFile(this, api, id)
    },
    actionFunc (action, id, param) {
      afunc.actionFunc(this, api, action, id, param)
    },
    mkTitel (data, mark) {
      return utils.mkTitel(data, mark)
    },
    async itemProvider (ctx) {
      try {
        const offset = (ctx.currentPage - 1) * ctx.perPage
        const pagedList = await api.auftraege(offset, ctx.perPage)
        this.rows = pagedList.size
        return pagedList.items
      } catch (error) {
        return []
      }
    },
    async refresh () {
      this.$refs.table.refresh()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/main/vue/components/Projekte.vue